import {
  ApiEnveloppe,
  CreateAlarmTemplateResponse,
  CreateGroupMailResponse,
  GetAllAlarmsWithIdProjectResponse,
  GetAllAlarmsXYWithIdProjectResponse,
  GetAllAlarmTemplatesWithIdProjectResponse,
  GetListMailGroupsWithIdProjectResponse,
} from '../../types/types';
import { _post, requestType } from './_internal';

export const getAllAlarmsWithIdProject = (payload: {
  list_project_id: any;
}): Promise<GetAllAlarmsWithIdProjectResponse> => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_alarmes,
    list_project_id: payload.list_project_id,
  });
};

export const getConfirmationAlarm = (payload: any) => {
  return _post({
    request_type: requestType.confirmer_une_alarme,
    ...payload,
  });
};

export const getListMailGroupsWithIdProject = (payload: {
  list_project_id: any;
}): Promise<GetListMailGroupsWithIdProjectResponse> => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_groupes_d_email,
    list_project_id: payload.list_project_id,
  });
};

export const createGroupMail = (
  payload: any
): Promise<CreateGroupMailResponse> => {
  return _post({
    request_type: requestType.creer_un_groupe_d_email,
    ...payload,
  });
};

export const updateGroupMail = (payload: any): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.modifier_un_groupe_d_email,
    ...payload,
  });
};

export const deleteGroupMail = (payload: {
  group_email_id: string;
}): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.supprimer_un_groupe_d_email,
    group_email_id: payload.group_email_id,
  });
};

export const createAlarmTemplate = (
  payload: any
): Promise<CreateAlarmTemplateResponse> => {
  return _post({
    request_type: requestType.creer_un_gabarit,
    ...payload,
  });
};

export const updateAlarmTemplate = (payload: any): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.modifier_un_gabarit,
    ...payload,
  });
};

export const deleteAlarmTemplate = (payload: {
  template_id: string;
}): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.supprimer_un_gabarit,
    template_id: payload.template_id,
  });
};

export const getAllAlarmTemplatesWithIdProject = (payload: {
  list_project_id: any;
}): Promise<GetAllAlarmTemplatesWithIdProjectResponse> => {
  return _post({
    request_type: requestType.recuperer_la_liste_des_gabarits,
    list_project_id: payload.list_project_id,
  });
};

export const createAlarmXY = (payload: any) => {
  return _post({
    request_type: requestType.configurer_des_alarmes_xy,
    ...payload,
  });
};

export const updateAlarmXY = (payload: any): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.modifier_des_alarmes_xy,
    ...payload,
  });
};

export const deleteAlarmXY = (payload: {
  alarm_xy_id: string;
}): Promise<ApiEnveloppe> => {
  return _post({
    request_type: requestType.supprimer_une_configuration_d_alarme_xy,
    alarm_xy_id: payload.alarm_xy_id,
  });
};

export const getAllAlarmsXYWithIdProject = (payload: {
  list_project_id: any;
}): Promise<GetAllAlarmsXYWithIdProjectResponse> => {
  return _post({
    request_type:
      requestType.recuperer_la_liste_des_configurations_des_alarmes_xy,
    list_project_id: payload.list_project_id,
  });
};
